
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.958 17.058c0-.765-.38-1.48-1.016-1.908l-1.017-.65a1.034 1.034 0 01-.467-.833v-2.934a5.643 5.643 0 00-2.833-4.883l-2.5-1.417a1.032 1.032 0 01-.525-.9v-.7h-1.25v.7c0 .373-.2.717-.525.9l-2.5 1.417a5.64 5.64 0 00-2.833 4.883v2.875c-.01.338-.185.649-.467.834l-1.017.675a2.3 2.3 0 00-1.016 1.908v1.4h5.491a3.526 3.526 0 007.034 0h5.441v-1.367zM12 20.542a2.275 2.275 0 01-2.267-2.084h4.534A2.276 2.276 0 0112 20.542zm7.708-3.334H4.292v-.15c.01-.337.184-.648.466-.833l1.017-.675a2.3 2.3 0 001.017-1.908v-2.909A4.384 4.384 0 019 6.933l2.5-1.408c.197-.113.376-.253.533-.417.158.164.337.304.534.417l2.5 1.408a4.384 4.384 0 012.208 3.8v2.875c0 .766.381 1.482 1.017 1.909l1.016.675c.283.185.457.496.467.833l-.067.183z","fill":"#71798A","fill-rule":"evenodd"}})])
          )
        }
      }
    